import { render, staticRenderFns } from "./safetyAndEnvironmentAssessment.vue?vue&type=template&id=baa23360&scoped=true&"
import script from "./safetyAndEnvironmentAssessment.vue?vue&type=script&lang=ts&"
export * from "./safetyAndEnvironmentAssessment.vue?vue&type=script&lang=ts&"
import style0 from "./safetyAndEnvironmentAssessment.vue?vue&type=style&index=0&id=baa23360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa23360",
  null
  
)

export default component.exports